import { render, staticRenderFns } from "./VersionMailList.vue?vue&type=template&id=230e5121&scoped=true"
import script from "./VersionMailList.vue?vue&type=script&lang=js"
export * from "./VersionMailList.vue?vue&type=script&lang=js"
import style0 from "./VersionMailList.vue?vue&type=style&index=0&id=230e5121&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "230e5121",
  null
  
)

export default component.exports